import React from 'react';
import { ProductEditTemplate } from 'themes/application/product/pages';
import { observer } from 'mobx-react';
import { ProductEditViewStore } from 'application/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductEditViewStore(rootStore), 'editView')
@observer
class ProductEdit extends React.Component {
    render() {
        return <ProductEditTemplate {...this.props} />
    }
}

export default ProductEdit;